'use strict';

const CATEGORY_SELECTOR = '.js-category-switcher';

export function init() {
    const element = document.querySelector(CATEGORY_SELECTOR);

    if (!element) {
        return false;
    }

    element.addEventListener('change', e => {
        window.location.href = e.target.value;
    })
}

export default { init }
